export class ProjectViewData {
  name: string;
  type_name:string;
  type_num:number;
  sqe:number;
  upload:number ;
  medcat_num:number;
  convert_num:number;
  validate_num:number;
  to_a_num:number;
  to_b_num:number;
}
